import { render, staticRenderFns } from "./Calculations.vue?vue&type=template&id=cb9df958&scoped=true&"
import script from "./Calculations.vue?vue&type=script&lang=js&"
export * from "./Calculations.vue?vue&type=script&lang=js&"
import style0 from "./Calculations.vue?vue&type=style&index=0&id=cb9df958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9df958",
  null
  
)

export default component.exports